export default __webpack_public_path__ + "static/media/cover.bfc1e367.png";